<script>
    import CursorTrail from "$lib/components/CursorTrail.svelte";
    import CelestialSky from "$lib/components/CelestialSky.svelte";
</script>

<svelte:head>
    <title>dinglandia | Contact Us</title>
    <meta
        name="description"
        content="We focus on delivering fast user experiences with unique user interface design. Get in touch to create your vision on the web."
    />

    <meta property="og:title" content="Contact Us" />
    <meta property="og:site_name" content="dinglandia" />
    <meta property="og:url" content="https://dinglandia.design/contact" />
    <meta
        property="og:description"
        content="We focus on delivering fast user experiences with unique user interface design. Get in touch to create your vision on the web."
    />
    <meta property="og:type" content="business.business" />
    <meta
        property="og:image"
        content="https://dinglandia.design/og/contact.jpg"
    />
</svelte:head>

<!-- Intro -->
<section id="intro" class="intro" data-trail="wrapper">
    <div class="icon-new" name="logo"></div>
    <h1 class="flash">contact</h1>

    <!-- Cursor Trail Images -->
    <CursorTrail />
</section>
<!-- //Intro -->

<!-- Down Arrow -->
<a href="#contact" aria-label="Jump to contact section">
    <svg class="icon icon-arrow down-arrow"
        ><use xlink:href="#icon-arrow"></use></svg
    >
</a>
<!-- //Down Arrow -->

<!-- Contact -->
<section id="contact" class="contact">
    <div class="container">
        <h2 class="text-center">Get In Touch</h2>
        <ul class="contact-nav">
            <li>
                <a
                    href="mailto:&#100;&#105;&#110;&#103;&#108;&#101;&#115;&#116;&#101;&#105;&#110;&#064;&#100;&#105;&#110;&#103;&#108;&#097;&#110;&#100;&#105;&#097;&#046;&#100;&#101;&#115;&#105;&#103;&#110;"
                    ><svg class="icon icon-email"
                        ><use xlink:href="#icon-email"></use></svg
                    > dinglestein@dinglandia.design</a
                >
            </li>
            <li>
                <a href="tel:672-881-0722"
                    ><svg class="icon icon-phone"
                        ><use xlink:href="#icon-phone"></use></svg
                    > 672-881-0722</a
                >
            </li>
        </ul>

        <div class="row">
            <div class="col-md-6 offset-md-3">
                <div class="d-grid gap-2 col-6 mx-auto">
                    <a
                        href="https://calendar.notion.so/meet/dinglestein/vx7t4o8v"
                        role="button"
                        class="btn btn-lg btn-custom"
                        target="_blank"
                        rel="noreferrer"
                    >
                        book a meeting
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- //Contact -->

<!-- New Mountain Parallax -->
<main class="content-grid">
    <section class="breakout">
        <CelestialSky />
        <div
            class="frame frame-square parallax-y"
            role="img"
            aria-label="Multi-layered scene depicting an underwater scene of some fish and Manta Ray. Set within the outline of a Manta Ray."
            style="--multiplier: 4"
        >
            <img src="/img/mountains/mtnBlu5.svg" alt="" style="--offset:0.1" />
            <img
                src="/img/mountains/mtnBlu4.svg"
                alt=""
                style="--offset:0.075"
            />
            <img
                src="/img/mountains/mtnBlue3.svg"
                alt=""
                style="--offset:0.05"
            />
            <img
                src="/img/mountains/mtnBlu2_fix.svg"
                alt=""
                style="--offset:0.025"
            />
            <img src="/img/mountains/mtnBlue.svg" alt="" style="--offset:0.012" />
            <div class="mountain-base"></div>
        </div>
        <p class="supports"></p>
    </section>
</main>
<!-- .//New Mountain Parallax -->

<!-- Services -->
<section id="services" class="services">
    <div class="container">
        <h2 class="text-center">What We Do</h2>
        <div class="services-grid">
            <a href="/services#v-pills-discover">
                <svg class="icon icon-discover"
                    ><use xlink:href="#icon-discover"></use></svg
                >
                <p>Discover</p>
            </a>
            <a href="/services#v-pills-design">
                <svg class="icon icon-design"
                    ><use xlink:href="#icon-design"></use></svg
                >
                <p>Design</p>
            </a>
            <a href="/services#v-pills-develop">
                <svg class="icon icon-develop"
                    ><use xlink:href="#icon-develop"></use></svg
                >
                <p>Develop</p>
            </a>
            <a href="/services#v-pills-devops">
                <svg class="icon icon-devops"
                    ><use xlink:href="#icon-devops"></use></svg
                >
                <p>DevOps</p>
            </a>
            <a href="/services#v-pills-agentic">
                <svg class="icon icon-robot"
                    ><use xlink:href="#icon-robot"></use></svg
                >
                <p>Agentic</p>
            </a>
        </div>

        <div class="row">
            <div class="col-md-6 offset-md-3">
                <div class="d-grid gap-2 col-6 mx-auto">
                    <a href="/work" class="btn btn-lg btn-custom" type="button"
                        >view work</a
                    >
                </div>
            </div>
        </div>
    </div>
</section>
<!-- //Services -->

<!-- Water Ripple CTA -->
<section class="ripple-cta">
    <div class="water-container">
        <canvas id="pool" aria-hidden="true"></canvas>
    </div>

    <div class="viking-ship-container">
        <svg
            class="viking-ship"
            viewBox="0 0 200 100"
            xmlns="http://www.w3.org/2000/svg"
            aria-label="Viking ship sailing"
        >
            <!-- Ship Hull -->
            <path
                d="M 20 50 Q 10 60, 20 70 L 180 70 Q 190 60, 180 50 Z"
                fill="#4a3426"
                stroke="#2a1f1a"
                stroke-width="2"
            />

            <!-- Hull Details -->
            <rect
                x="25"
                y="55"
                width="150"
                height="3"
                fill="#3a2920"
                opacity="0.7"
            />
            <rect
                x="25"
                y="62"
                width="150"
                height="2"
                fill="#3a2920"
                opacity="0.5"
            />

            <!-- Mast -->
            <rect x="98" y="15" width="4" height="45" fill="#2a1f1a" />

            <!-- Sail -->
            <path
                d="M 45 20 Q 100 25, 155 20 L 150 45 Q 100 48, 50 45 Z"
                fill="#e8d5c4"
                stroke="#2a1f1a"
                stroke-width="1.5"
                opacity="0.95"
            />

            <!-- Sail Stripes -->
            <rect
                x="50"
                y="25"
                width="100"
                height="4"
                fill="#b84c4c"
                opacity="0.8"
            />
            <rect
                x="50"
                y="33"
                width="100"
                height="4"
                fill="#b84c4c"
                opacity="0.8"
            />
            <rect
                x="50"
                y="41"
                width="100"
                height="3"
                fill="#b84c4c"
                opacity="0.8"
            />

            <!-- Shield decorations -->
            <circle
                cx="40"
                cy="60"
                r="6"
                fill="#b84c4c"
                stroke="#2a1f1a"
                stroke-width="1"
            />
            <circle
                cx="60"
                cy="60"
                r="6"
                fill="#4a7299"
                stroke="#2a1f1a"
                stroke-width="1"
            />
            <circle
                cx="80"
                cy="60"
                r="6"
                fill="#b84c4c"
                stroke="#2a1f1a"
                stroke-width="1"
            />
            <circle
                cx="100"
                cy="60"
                r="6"
                fill="#4a7299"
                stroke="#2a1f1a"
                stroke-width="1"
            />
            <circle
                cx="120"
                cy="60"
                r="6"
                fill="#b84c4c"
                stroke="#2a1f1a"
                stroke-width="1"
            />
            <circle
                cx="140"
                cy="60"
                r="6"
                fill="#4a7299"
                stroke="#2a1f1a"
                stroke-width="1"
            />
            <circle
                cx="160"
                cy="60"
                r="6"
                fill="#b84c4c"
                stroke="#2a1f1a"
                stroke-width="1"
            />

            <!-- Dragon head -->
            <path
                d="M 180 50 Q 195 45, 197 50 L 195 55 Q 190 52, 180 52 Z"
                fill="#4a3426"
                stroke="#2a1f1a"
                stroke-width="1.5"
            />

            <!-- Oars (simplified) -->
            <line
                x1="35"
                y1="68"
                x2="28"
                y2="78"
                stroke="#2a1f1a"
                stroke-width="2"
                stroke-linecap="round"
            />
            <line
                x1="55"
                y1="68"
                x2="48"
                y2="78"
                stroke="#2a1f1a"
                stroke-width="2"
                stroke-linecap="round"
            />
            <line
                x1="75"
                y1="68"
                x2="68"
                y2="78"
                stroke="#2a1f1a"
                stroke-width="2"
                stroke-linecap="round"
            />
            <line
                x1="125"
                y1="68"
                x2="132"
                y2="78"
                stroke="#2a1f1a"
                stroke-width="2"
                stroke-linecap="round"
            />
            <line
                x1="145"
                y1="68"
                x2="152"
                y2="78"
                stroke="#2a1f1a"
                stroke-width="2"
                stroke-linecap="round"
            />
            <line
                x1="165"
                y1="68"
                x2="172"
                y2="78"
                stroke="#2a1f1a"
                stroke-width="2"
                stroke-linecap="round"
            />
        </svg>
    </div>

    <div class="trees trees--cta" aria-hidden="true"></div>

    <div class="overlay" aria-hidden="true">
        <div class="overlay-inner">
            <h2 class="title">We take you from point A to point B.</h2>
            <h3 class="subtitle">And everywhere in-between.</h3>
            <div class="cta">
                Let's create custom web experiences for your customers!
            </div>
            <div class="logo-tag">
                <button
                    type="button"
                    class="btn btn-lg btn-custom"
                    data-fillout-id="n2vCxyr9Huus"
                    data-fillout-embed-type="popup"
                    data-fillout-dynamic-resize
                    data-fillout-inherit-parameters
                    data-fillout-popup-size="small">navigate the winds</button
                >
            </div>
        </div>
    </div>

    <!-- <div class="scroll-indicator">↓ scroll to sail ↓</div> -->

    <div class="fallback" hidden aria-hidden="true">
        WebGL2 is required to view this water effect.<br />
        Please try again in a modern browser.
    </div>
</section>
<!-- Water Ripple CTA -->
